import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router';

Vue.use(Vuex);

export const SET_USER = 'SET_USER';
export const SET_MENU = 'SET_MENU';
export const SET_MOBILE_MENU = 'SET_MOBILE_MENU';
export const SET_LOADING = 'SET_LOADING';
export const REQUIRE_LOGIN = 'REQUIRE_LOGIN';

export default new Vuex.Store({
  state: {
    user: null,
    isMenuShrink: false,
    isMobileMenu: false,
    isSpanHidden: false,
    isMenuLoading: false,
    isLoading: false,
  },
  getters: {
    role: ({ user }) => {
      if (!user) return null;
      return user.role;
    },
  },
  mutations: {
    [SET_USER]: (state, payload) => {
      state.user = payload;
    },
    [SET_MENU]: (state) => {
      if (!state.isMenuLoading) {
        state.isMenuLoading = true;
        state.isMenuShrink = !state.isMenuShrink;
        if (state.isSpanHidden) {
          setTimeout(() => {
            state.isSpanHidden = false;
          }, 250);
        } else {
          state.isSpanHidden = true;
        }
        setTimeout(() => {
          state.isMenuLoading = false;
        }, 500);
      }
    },
    [SET_MOBILE_MENU]: (state) => {
      state.isMobileMenu = !state.isMobileMenu;
    },
    [SET_LOADING]: (state, isLoading) => {
      state.isLoading = isLoading;
    },
  },
  actions: {
    [REQUIRE_LOGIN]: ({ commit }, type) => {
      if (type === 'INACTIVATED') {
        alert('你帳戶好似有問題。請聯絡ecoupon@ulifestyle.com.hk');
      } else {
        alert('資料連線中斷，請重新整理網頁');
      }
      commit(SET_USER, null);
      router.go(0);
    },
  },
  modules: {},
});
